export const consentPropertyType = "site_consent";
export const cookieConsentPropertyType = "CookieConsent";
export const CONST_GENDER_FEMALE = 2;
export const CONST_GENDER_MALE = 1;

export const landingId = "b79094063dc58fa7836e0112eb7067db"
export const IS_VISIBLE_CUSTOM_AUTOCOMPLETE = false;

export const genderLabel = {
  [CONST_GENDER_MALE]: "Man, looking for a woman",
  [CONST_GENDER_FEMALE]: "Woman, looking for a man",
};

export const errorEventsName = {
  empty: "err_lnd_name_noname",
  too_short: "err_lnd_name_shortname",
  invalid_chars: "err_lnd_name_symbolname",
};

export const errorEventsBirthday = {
  M: "err_lnd_age_onlymonth",
  D: "err_lnd_age_onlyday",
  Y: "err_lnd_age_onlyyear",
  MD: "err_lnd_age_onlydaymonth",
  DY: "err_lnd_age_onlydayyear",
  MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
  "Please enter your email": "err_lnd_email_noemail",
  "Please enter a valid email": "err_lnd_email_wrongemail",
};
export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";

export const ERROR_EMAIL_ALREADY_REGISTERED = "This email is already registered"
export const errorEventsPassword = {
  empty: "err_lnd_password_nopassword",
  too_short: "err_lnd_password_shortpassword",
};

export const domains = [
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@aol.com",
  "@outlook.com",
  "@comcast.net",
  "@live.com",
  "@mail.com",
  "@msn.com",
  "@att.net",
  "@icloud.com",
];
